import { portBanner, type PortId, type SceneId } from '@/lib/assets';

export type Faction = 'english_crown' | 'spanish' | 'french' | 'free_port' | 'pirate_haven';

export interface PortMeta {
  id: PortId;
  name: string;
  faction: Faction;
  tagline: string;
  banner: string;
  background: SceneId;
}

export const PORTS: Record<string, PortMeta> = {
  cutlass_cove: {
    id: 'cutlass_cove',
    name: 'Cutlass Cove',
    faction: 'pirate_haven',
    tagline: 'A hidden bay where tales begin.',
    banner: portBanner('cutlass_cove'),
    background: 'dock_at_night',
  },
  port_royale: {
    id: 'port_royale',
    name: 'Port Royale',
    faction: 'english_crown',
    tagline: 'The wicked jewel of the Crown.',
    banner: portBanner('port_royale'),
    background: 'marketplace',
  },
  tortuga: {
    id: 'tortuga',
    name: 'Tortuga',
    faction: 'pirate_haven',
    tagline: "The pirate's open haven.",
    banner: portBanner('tortuga'),
    background: 'tavern_interior',
  },
  nassau: {
    id: 'nassau',
    name: 'Nassau',
    faction: 'free_port',
    tagline: 'Privateer waters.',
    banner: portBanner('nassau'),
    background: 'quarterdeck',
  },
  charleston: {
    id: 'charleston',
    name: 'Charleston',
    faction: 'english_crown',
    tagline: 'Naval discipline.',
    banner: portBanner('charleston'),
    background: 'training_yard',
  },
  havana: {
    id: 'havana',
    name: 'Havana',
    faction: 'spanish',
    tagline: 'Spanish steel and silver.',
    banner: portBanner('havana'),
    background: 'marketplace',
  },
  saint_domingue: {
    id: 'saint_domingue',
    name: 'Saint-Domingue',
    faction: 'french',
    tagline: 'French sugar, French swords.',
    banner: portBanner('saint_domingue'),
    background: 'shipyard',
  },
  maracaibo: {
    id: 'maracaibo',
    name: 'Maracaibo',
    faction: 'free_port',
    tagline: 'Deep harbor, deeper secrets.',
    banner: portBanner('maracaibo'),
    background: 'captains_cabin',
  },
};

export function getPortMeta(id: string): PortMeta {
  // Schema stores 'saint-domingue' with a hyphen, but the asset filename
  // uses an underscore. Normalise.
  const normalised = id.replace(/-/g, '_');
  return (
    PORTS[normalised] ?? {
      id: normalised as PortId,
      name: id,
      faction: 'free_port' as Faction,
      tagline: 'An unfamiliar harbor.',
      banner: portBanner(normalised),
      background: 'dock_at_night' as SceneId,
    }
  );
}
